import { useSelector } from 'react-redux'
import { EventLocation, Duration, Price } from '@calendly/booking-kit'

import DetailsContainer from 'components/enter_details/details_container'
import EventTime from 'components/details/event_time'
import Timezone from 'components/details/timezone'
import Profile from 'components/profile'
import { eventTypeSelector } from 'root-api'
import {
  timeNotationSelector,
  eventSelector
} from 'selectors'
import { timezoneSelector } from 'selectors/invitee'
import { currentInviteeSelector } from 'selectors/current_invitee'
import SidePanel from 'components/layout/side_panel'

const CancellationSidePanel = () => {
  const eventType = useSelector(eventTypeSelector)
  const event = useSelector(eventSelector)
  const invitee = useSelector(currentInviteeSelector)
  const timezone = useSelector(timezoneSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const hasMeetingPackage = invitee?.event?.package_fulfillment_uuid
  const { avatar_url: avatarUrl, logo_url: logoUrl } = event.scheduled_profile

  return (
    <SidePanel narrow>
      <Profile
        avatar={avatarUrl}
        name={event.publishers_list}
        logoUrl={logoUrl}
        eventTypeName={event.name}
        sidebar
      />
      <DetailsContainer>
        <Duration value={eventType.duration} />
        <EventLocation event={event} />
        {!hasMeetingPackage && (<Price source={eventType} />)}
        <EventTime
          source={event}
          timezone={timezone}
          timeNotation={timeNotation}
        />
        <Timezone value={timezone} />
      </DetailsContainer>
    </SidePanel>
  )
}

export default CancellationSidePanel
